export default __webpack_public_path__ + "static/media/KEI.a1a80ae8.png";